// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__6Ya_a","col":"styles_col__16DzT","fulfillmentStatus":"styles_fulfillmentStatus__3uMlA","emailCol":"styles_emailCol__2Jwxy"};